import SectionVisible from 'appContainer/SectionVisible';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { MarkdownRenderer, Stack, Typography } from 'styles';
import { IHistoryItem } from 'types/History';
import { SECTIONS } from 'types/SectionsVisibility';

type Props = {
	item: IHistoryItem;
};

const FraudContent = ({ item }: Props) => {
	const { claimData: claim } = useSelector((store: RootState) => store.claim);
	const { fraudStatuses } = useSelector((store: RootState) => store.form);
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});

	const statusLabel = fraudStatuses.find(
		status => status.code === item.investigationStatusCode,
	)?.label;

	return (
		<Stack gap="5px">
			<Typography variant="body">
				{tClientLabels('claim.history.fraudStatusChanged', {
					status: tDbLabels(statusLabel || ''),
				})}
			</Typography>

			{item.reasonCode && item.reasonCodeLabel && (
				<Typography
					variant="body"
					sx={{
						'& > p': { padding: 0, margin: 0 },
						'& > ul': { margin: 0, paddingLeft: '20px' },
						'& > ul > li > p': { padding: 0, margin: 0 },
					}}
				>
					<MarkdownRenderer>
						{tClientLabels('claim.history.reasonCode', {
							reasonCode: tDbLabels(item.reasonCodeLabel),
						})}
					</MarkdownRenderer>
				</Typography>
			)}

			{item.internalNote && (
				<>
					<SectionVisible
						sectionName={SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS}
						carrier={{ customLayout: claim.customLayout }}
					>
						<Typography
							variant="body"
							sx={{
								'& > p': { padding: 0, margin: 0 },
								'& > ul': { margin: 0, paddingLeft: '20px' },
								'& > ul > li > p': { padding: 0, margin: 0 },
							}}
						>
							<MarkdownRenderer>
								{tClientLabels('claim.history.argument', {
									argument: item.internalNote,
								})}
							</MarkdownRenderer>
						</Typography>
					</SectionVisible>
					<SectionVisible
						sectionName={SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS}
						carrier={{ customLayout: claim.customLayout }}
					>
						<Typography
							variant="body"
							sx={{
								'& > p': { padding: 0, margin: 0 },
								'& > ul': { margin: 0, paddingLeft: '20px' },
								'& > ul > li > p': { padding: 0, margin: 0 },
							}}
						>
							<MarkdownRenderer>
								{tClientLabels('claim.history.denialReason', {
									reasonText: item.internalNote,
								})}
							</MarkdownRenderer>
						</Typography>
					</SectionVisible>
				</>
			)}
		</Stack>
	);
};

export default FraudContent;
